import axios from 'axios';
import { API_BASE_URL } from '../config';

const SESSION_KEY = 'bbtv_product_analytics_session_id';
const CONTRACT_VERSION = 'v1';
const DECISION_EVENTS = {
  shown: 'RECOMMENDATION_SHOWN',
  accepted: 'RECOMMENDATION_ACCEPTED',
  skipped: 'RECOMMENDATION_SKIPPED',
  wow: 'DECISION_WOW',
  recipeRejectedReason: 'RECIPE_REJECTED_REASON'
};

function randomId(prefix = 'evt') {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}_${crypto.randomUUID().replace(/-/g, '')}`;
  }
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

function getSessionId() {
  try {
    const existing = sessionStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const next = randomId('sess');
    sessionStorage.setItem(SESSION_KEY, next);
    return next;
  } catch (_err) {
    return randomId('sess');
  }
}

function getAuthToken() {
  try {
    return localStorage.getItem('authToken');
  } catch (_err) {
    return null;
  }
}

export async function trackProductEvent(event, options = {}) {
  const token = getAuthToken();
  if (!token) return { skipped: true, reason: 'missing_auth_token' };

  const now = new Date().toISOString();
  const payload = {
    eventId: options.eventId || randomId('evt'),
    event,
    schemaVersion: CONTRACT_VERSION,
    sessionId: options.sessionId || getSessionId(),
    occurredAt: options.occurredAt || now,
    receivedAt: now,
    source: options.source || 'app',
    surface: options.surface || 'unknown_surface',
    context: options.context || 'default',
    environment: options.environment || (process.env.NODE_ENV || 'development'),
    actorType: options.actorType || 'user',
    isTest: Boolean(options.isTest),
    userSegment: options.userSegment || null,
    planType: options.planType || null,
    householdType: options.householdType || null,
    experiment: options.experiment && typeof options.experiment === 'object' ? options.experiment : undefined,
    prediction: options.prediction && typeof options.prediction === 'object' ? options.prediction : undefined,
    metadata: options.metadata && typeof options.metadata === 'object' ? options.metadata : {}
  };

  try {
    const res = await axios.post(`${API_BASE_URL}/api/analytics/events`, payload, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.error || 'track_event_failed',
      details: error?.response?.data?.details || null
    };
  }
}

export function trackRecommendationShown(options = {}) {
  return trackProductEvent(DECISION_EVENTS.shown, options);
}

export function trackRecommendationAccepted(options = {}) {
  return trackProductEvent(DECISION_EVENTS.accepted, options);
}

export function trackRecommendationSkipped(options = {}) {
  return trackProductEvent(DECISION_EVENTS.skipped, options);
}

export function trackDecisionWow(options = {}) {
  return trackProductEvent(DECISION_EVENTS.wow, options);
}

export function trackRecipeRejectedReason(options = {}) {
  return trackProductEvent(DECISION_EVENTS.recipeRejectedReason, options);
}
